import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiGridColOne, UiCol } from "../../../../../library/layout/Index";
import ProdIOOExoCMNEditor from './ProdIOOExoCMNEditor';

const ProdIOOExoMaterialEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ actionParam:{actionType: 'addPlanItem'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '250px' }}
            formStyle={{ width: '535px', height:"400px" }} formTitle={<SarasTrans value="Item Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <ProdIOOExoCMNEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(ProdIOOExoMaterialEditor, "prodIOPlan", "prodEOOutputGroup,prodIOEOGroup")